<template>
  <div>
    <div v-for="item in list" :key="item.id">
      <table-item :data="item.data" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { gridOptions } from "@/utils/tableConfig.js";
import TableItem from "./tableItem.vue";
import { getAttriColumn, getAttriData } from "./config";

export default {
  data() {
    return {
      list: [],
      gridOptions: { ...gridOptions },
      validRules: {},
    };
  },
  components: { TableItem },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const { id, classId, subClassId } = this.$route.query;
      const obj = { id, classId, subClassId };
      axios
        .get(`/pmdm/changes/loadTotalCustomizeForm${this.params(obj)}`)
        .then((res) => {
          console.log(res);
          this.list = res.data.object.customizeFormTable
            .filter(i => {
              const { customizeFrameVO } = i
              return !!(customizeFrameVO.enabled)
            })
            .map((i) => {
            const { attrUiList, id } = i.customizeFrameVO,
              { rows } = i;
            const columns = getAttriColumn(attrUiList),
              data = getAttriData(rows, columns);
            console.log({ data });
            columns.forEach((element) => {
              const { required, field } = element;
              if (required == "1") {
                this.validRules[field] = {
                  required: true,
                  message: "名称必须填写",
                };
              }
            });
            return { id, data: { columns, data, id } };
          });
        });
    },
  },
};
</script>

<style>
</style>